import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=65958c80&scoped=true&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=65958c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65958c80",
  null
  
)

export default component.exports